import { Icon } from '../../components/ui/Icon';
import type { AuditEntry } from '../../data/types/platform';

export interface AdminAuditProps {
  audit: AuditEntry[];
}

export function AdminAudit({ audit }: AdminAuditProps) {
  return (
    <div className="admin-audit">
      <div className="admin-section-head">
        <h2>יומן פעולות אדמין</h2>
        <span className="cell-dim">לפי כרונולוגיה הפוכה · 30 ימים אחרונים</span>
      </div>
      <div className="audit-list">
        {audit.map((e) => (
          <div className="audit-row" key={e.id}>
            <div className="audit-who-icon">
              <Icon name="user" size={14} />
            </div>
            <div className="audit-text">
              <div>
                <b>{e.who}</b> {e.what} <span className="audit-target">{e.target}</span>
              </div>
              <div className="audit-meta">
                {e.time}
                {e.sys !== '—' && <> · <span className="cell-dim">{e.sys}</span></>}
              </div>
            </div>
            <button className="admin-row-action" title="עוד" type="button">
              <Icon name="more-horizontal" size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
